// docs: https://github.com/altostra/type-validations#readme
import { objectOf, recordOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isCampaignEmailClickDailyStatsResult = recordOf({
  key: string,
  value: recordOf({
    key: string,
    value: objectOf({
      clicks_by_path: recordOf({
        value: recordOf({
          key: string,
          value: objectOf({
            total_clicks: number,
            param_urls: recordOf({
              key: string,
              value: number,
            }),
          }),
        }),
      }),
      total_clicks: number,
      results_truncated: boolean,
    }),
  }),
});
